import { makeAutoObservable, runInAction } from 'mobx'
import { Package } from '../models/Payments'
import agent from '../api/agent'

export default class PackageStore {
  packageRegistry = new Map<string, Package>()

  loadingPackages = true

  constructor() {
    makeAutoObservable(this)
  }

  get packages() {
    return Array.from(this.packageRegistry.values())
  }

  loadPackages = async () => {
    this.loadingPackages = true
    const { status, data: packages } = await agent.Packages.list()
    if (status === 200) {
      runInAction(() => {
        packages.forEach((p) => {
          this.packageRegistry.set(p.id, p)
        })
        this.loadingPackages = false
      })
    }
  }
}
